import { render, staticRenderFns } from "./GeneralText33.vue?vue&type=template&id=80d9a880&scoped=true&"
import script from "./GeneralText33.vue?vue&type=script&lang=js&"
export * from "./GeneralText33.vue?vue&type=script&lang=js&"
import style0 from "./GeneralText33.vue?vue&type=style&index=0&id=80d9a880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d9a880",
  null
  
)

export default component.exports